import React from 'react'
import { Avatar, Button, Dropdown } from 'components/ui'
import withHeaderItem from 'utils/hoc/withHeaderItem'
import useAuth from 'utils/hooks/useAuth'
// import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import {
    HiOutlineUser,
    HiOutlineLogout,
    HiOutlineCog,
    HiChevronDown,
} from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { ADMIN, USER } from 'constants/roles.constant'
import {
    setAuthPanelLoginExpand,
    setAuthPanelSignupExpand,
} from 'store/theme/themeSlice'

export const UserDropdown = ({ className }) => {
    // bind this
    const userInfo = useSelector((state) => state.auth.user)
    const userAuthority = useSelector((state) => state.auth.user.authority)

    const { signOut } = useAuth()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const dropdownItemList = [
        {
            label: 'Dashboard',
            onClick: () => {
                navigate('/dashboard/accountDetails')
            },
            icon: <HiOutlineCog />,
        },
    ]

    const UserAvatar = (
        <div className={classNames(className, 'flex items-center gap-1')}>
            <Avatar size={26} shape="circle" icon={<HiOutlineUser />} />
            <div className="hidden md:block">
                <div className="font-bold text-black">{userInfo.name}</div>
            </div>
            <HiChevronDown size={18} className="text-black" />
        </div>
    )

    return (
        <div>
            {userAuthority.includes(USER) || userAuthority.includes(ADMIN) ? (
                <Dropdown
                    menuStyle={{ minWidth: 240 }}
                    renderTitle={UserAvatar}
                    placement="bottom-end"
                >
                    <Dropdown.Item variant="header">
                        <div className="py-2 px-3 flex items-center gap-2">
                            <Avatar shape="circle" icon={<HiOutlineUser />} />
                            <div>
                                <div className="font-bold text-gray-900 dark:text-gray-100">
                                    {userInfo.name}
                                </div>
                                <div className="text-xs">{userInfo.email}</div>
                            </div>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Item variant="divider" />
                    {dropdownItemList.map((item) => (
                        <Dropdown.Item
                            eventKey={item.label}
                            key={item.label}
                            className="mb-1"
                        >
                            {item.path && (
                                <Link
                                    className="flex gap-2 items-center"
                                    to={item.path}
                                >
                                    <span className="text-xl opacity-50">
                                        {item.icon}
                                    </span>
                                    <span>{item.label}</span>
                                </Link>
                            )}
                            {item.onClick && (
                                <span
                                    onClick={item.onClick}
                                    className="flex gap-2 items-center"
                                >
                                    <span className="text-xl opacity-50">
                                        {item.icon}
                                    </span>
                                    <span>{item.label}</span>
                                </span>
                            )}
                        </Dropdown.Item>
                    ))}
                    {/* <Dropdown.Item variant="divider" /> */}
                    <Dropdown.Item
                        onClick={signOut}
                        eventKey="Sign Out"
                        className="gap-2"
                    >
                        <span className="text-xl opacity-50">
                            <HiOutlineLogout />
                        </span>
                        <span>Sign Out</span>
                    </Dropdown.Item>
                </Dropdown>
            ) : (
                <div className="flex justify-between items-center gap-3 mx-4">
                    <Button
                        block
                        type="submit"
                        size="sm"
                        onClick={() => dispatch(setAuthPanelLoginExpand(true))}
                    >
                        {'Login'}
                    </Button>
                    <Button
                        block
                        variant="solid"
                        type="submit"
                        size="sm"
                        onClick={() => dispatch(setAuthPanelSignupExpand(true))}
                    >
                        {'Sign Up'}
                    </Button>
                </div>
            )}
        </div>
    )
}

export default withHeaderItem(UserDropdown)
